var pa2 = "/static/cf71555cc15c39b3.png";

export { pa2 as default };
//# sourceMappingURL=pa_2.png.js.map
